import React from 'react';
import { MapContainer, Marker, Popup, TileLayer, Tooltip, LayersControl, LayerGroup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import HomeAdd from '../../assets/icons/HomeAdd.svg';
import OfficeAdd from '../../assets/icons/OfficeAdd.svg';
import OtherAdd from '../../assets/icons/OtherAdd.svg';
import { useLocalization } from '../Context/MultiLanguageContext';

export interface Address {
  id: string;
  latitude: number;
  longitude: number;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  pinCode: string;
  addressType?: string;
}
const openGoogleMaps = (latitude: number, longitude: number) => {
  const defaultMap = localStorage.getItem("defaultMap") || "google";

  if (defaultMap === "waze") {
    const wazeMapsUrl = `https://waze.com/ul?ll=${latitude},${longitude}&navigate=yes`;
    window.open(wazeMapsUrl, '_blank');
  } else if (defaultMap === "mapindia") {
    const mapplsUrl = `https://www.mappls.com/@${latitude},${longitude}`;
    window.open(mapplsUrl, "_blank");
  } else if (defaultMap === "apple") {
    const appleMapsUrl = `https://maps.apple.com/?ll=${latitude},${longitude}&q=${latitude},${longitude}&z=18&t=m`;
    window.open(appleMapsUrl, "_blank");
  } else {
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
    window.open(googleMapsUrl, '_blank');
  }
};

interface MapAddressDetailsProps {
  addresses: Address[];
}

const getAddressTypeIconHtml = (addressType: string) => {
  const type = addressType.toLowerCase();
  if (type === 'home') {
    return `<img src="${HomeAdd}" alt="Home" style="width:40px; height:40px;" />`;
  } else if (type === 'office') {
    return `<img src="${OfficeAdd}" alt="Office" style="width:40px; height:40px;" />`;
  } else {
    return `<img src="${OtherAdd}" alt="Other" style="width:40px; height:40px;" />`;
  }
};

const createCustomIcon = (addressType: string): L.DivIcon => {
  return L.divIcon({
    html: getAddressTypeIconHtml(addressType),
    iconSize: [60, 60],
    className: 'custom-div-icon'
  });
};

const MapAddressDetails: React.FC<MapAddressDetailsProps> = ({ addresses }) => {
  const { t } = useLocalization();

  const center: [number, number] = addresses.length > 0
    ? [addresses[0].latitude, addresses[0].longitude]
    : [9.9921, 76.3019];

  return (
    <MapContainer center={center} zoom={17} className="h-[250px] sm:h-[300px] md:h-[350px] w-full">

      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />


      {addresses.map((address) => (
        <Marker
          key={address.id || `${address.latitude}-${address.longitude}`}
          position={[address.latitude, address.longitude]}
          icon={createCustomIcon(address.addressType || 'other')}
          eventHandlers={{
            click: () => openGoogleMaps(address.latitude, address.longitude),
          }}
        >
          <Tooltip direction="top" offset={[0, -10]} opacity={1} permanent>
            <span>{address.addressLine3}</span>
          </Tooltip>
          <Popup>
            <div>
              <strong>{t("address")}:</strong> {address.addressLine1}, {address.addressLine2}<br />
              <strong>{t("street")}:</strong>{address.addressLine3}<br />
              <strong>{t("postalCode")}:</strong> {address.pinCode}<br />
            </div>
          </Popup>
        </Marker>
      ))}

    </MapContainer>
  );
};

export default MapAddressDetails;
